/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkOrderMergeSuggestionClusterDto } from './WorkOrderMergeSuggestionClusterDto';
import {
    WorkOrderMergeSuggestionClusterDtoFromJSON,
    WorkOrderMergeSuggestionClusterDtoFromJSONTyped,
    WorkOrderMergeSuggestionClusterDtoToJSON,
    WorkOrderMergeSuggestionClusterDtoToJSONTyped,
} from './WorkOrderMergeSuggestionClusterDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface WorkOrderMergeSuggestionsResponseDto
 */
export interface WorkOrderMergeSuggestionsResponseDto {
    /**
     * 
     * @type {Array<WorkOrderMergeSuggestionClusterDto>}
     * @memberof WorkOrderMergeSuggestionsResponseDto
     */
    clusters: Array<WorkOrderMergeSuggestionClusterDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof WorkOrderMergeSuggestionsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the WorkOrderMergeSuggestionsResponseDto interface.
 */
export function instanceOfWorkOrderMergeSuggestionsResponseDto(value: object): value is WorkOrderMergeSuggestionsResponseDto {
    if (!('clusters' in value) || value['clusters'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function WorkOrderMergeSuggestionsResponseDtoFromJSON(json: any): WorkOrderMergeSuggestionsResponseDto {
    return WorkOrderMergeSuggestionsResponseDtoFromJSONTyped(json, false);
}

export function WorkOrderMergeSuggestionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderMergeSuggestionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'clusters': ((json['clusters'] as Array<any>).map(WorkOrderMergeSuggestionClusterDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function WorkOrderMergeSuggestionsResponseDtoToJSON(json: any): WorkOrderMergeSuggestionsResponseDto {
    return WorkOrderMergeSuggestionsResponseDtoToJSONTyped(json, false);
}

export function WorkOrderMergeSuggestionsResponseDtoToJSONTyped(value?: WorkOrderMergeSuggestionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clusters': ((value['clusters'] as Array<any>).map(WorkOrderMergeSuggestionClusterDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

